/**
 * LoaderState is an object that contains the current state of the media player.
 *
 * @type {class}
 */
export default class LoaderState {
    constructor(isLoading = false, isLoaded = false, error = null) {
        this.isLoading = isLoading;
        this.isLoaded = isLoaded;
        this.error = error;
    }
    clone() {
        return new LoaderState(this.isLoading, this.isLoaded, this.error);
    }
}
